export const getRoundedValue = (value: string) => {
  return (Math.round((Number(value) + Number.EPSILON) * 100) / 100).toFixed(2);
};